import { NgModule } from '@angular/core';
import { SecurityService } from '@app-lib';
import { FlatpickrDefaults, FlatpickrModule } from 'angularx-flatpickr';
import flatpickr from 'flatpickr';
import { english } from 'flatpickr/dist/l10n/default.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';

// import {} from '../../../../../node_modules/flatpickr/dist/l10n';
// https://stackoverflow.com/questions/55991736/error-when-loading-locale-on-angular-using-angularx-flatpickr
export function flatpickrLocalize(locale: string = 'it') {
  switch (locale) {
    case 'en':
      flatpickr.localize(english);
      break;
    case 'it':
      flatpickr.localize(Italian);
      break;

    case 'fr':
      flatpickr.localize(French);
      break;

    case 'pl':
      flatpickr.localize(Polish);
      break;

    default:
      break;
  }
}

// import {} from '../../../../../node_modules/flatpickr/dist/l10n';
// https://stackoverflow.com/questions/55991736/error-when-loading-locale-on-angular-using-angularx-flatpickr
/*
export function flatpickrLocalizeb(locale: string = 'it') {
  const l = require(`flatpickr/dist/l10n/${locale}.js`);
  flatpickr.localize(l.default[locale]);
  return flatpickr;
}*/
/*
export function flatpickrLocalizationbak() {
  flatpickr.localize(Portuguese);
  return flatpickr;
}*/
@NgModule({
  imports: [FlatpickrModule],
  exports: [FlatpickrModule],
  providers: [FlatpickrDefaults],
})
export class InitLocalesForFlatpickrModule {
  constructor(private _security: SecurityService) {
    const lng = _security.Get_Culture();
    flatpickrLocalize(lng);
  }
}
